import { useEffect, useState } from 'react';
import React from 'react';
import styles from './../styles.module.scss';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@store/types';

type leftNav = {
    id: string,
    title: string, 
    url: string, 
    disabled?: boolean,
    iconRef?: any
};

const LeftNav: React.FC<{selected_id: string}> = ({selected_id}) => {
    const [navList, setNavList]= useState<leftNav[]>([]);
    const { envVariables: Env } = useSelector((store:RootState)=> store.AccountReducer);
    
    useEffect(() => {
        const nav: leftNav[] =  [
            {
                id: 'user',
                title: 'User Management',
                iconRef: '/icons/user-manage.svg',
                url: '/admin/user-management'
            }
        ]
            Env?.ENABLE_GROUP_MANAGEMENT && nav.push({
                id: 'group',
                title: 'Group Management',
                iconRef: '/icons/user-manage.svg',
                url: '/admin/group-management'
            }),
        
        setNavList(nav);
    }, [Env]);

    return (
        <div
            className={classNames(styles["treeview__container"])}
        >   
            <h2 className={styles["header"]}>Administrator</h2>
            <ul className="">
                {navList.map((tab) => (
                     <Link to={tab.url}  key={tab.id}>
                        <li
                            key={tab.id}
                            className={classNames( {
                                [styles["selected"]]: tab.id === selected_id,
                            })}
                        >
                            <Link to={tab.url}>
                                <img src={tab.iconRef} />
                                <span>{tab.title}</span>
                            </Link>
                        </li>
                     </Link>
                ))}
            </ul>
        </div>
    );
};

export default LeftNav;
